import { useCallback } from 'react';

import { useUpdateUserSettings } from './use-update-user-settings';

export const useClearAllTasksFilters = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    () => updateSettings({ allTasks: { filterByTags: [] } }),
    [updateSettings],
  );
};
